import { generateAsyncAction } from 'lib/action-generators';
import { ASSISTANT_AI_ESTIE_CHAT } from './constants';
import graphql from 'lib/api/graphql';
import assistantAiChat from '../graphql/queries/assistant-ai-chat.graphql';

export const AssistantAiActions = {
  assistantAiChat: searchConfig =>
    generateAsyncAction(
      ASSISTANT_AI_ESTIE_CHAT,
      searchConfig,
      graphql(assistantAiChat, searchConfig),
      'assistantAiChat'
    ),
};
